import {Component, HostListener, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {TransactionService} from './transaction.service';
import {CustomerService} from '../customer/customer.service';
import {NgbActiveModal, NgbModal, NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';
import {ActionType, IActionType} from '../../shared/model/action-type.model';
import {ActionTypeService} from '../action-type/action-type.service';
import {User} from '../../core/user/user.model';
import {UserService} from '../../core/user/user.service';
import * as moment from 'jalali-moment';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActionTypeUpdateComponent} from '../action-type/action-type-update.component';
import {Organization} from '../../shared/model/organization.model';
import {Employee, IEmployee} from '../../shared/model/employee.model';
import {EmployeeService} from '../../core/employee/employee.service';
import {PhoneService} from '../phone/phone.service';
import {IPhone} from '../../shared/model/phone.model';
import {Contract, IContract} from '../../shared/model/contract.model';
import {ContractService} from '../contract/contract.service';
import {IProject, Project} from '../../shared/model/project.model';
import {ProjectService} from '../project/project.service';
import {FileObject, IFileObject} from "../../shared/model/file-object.model";
import {JhiDataUtils} from "ng-jhipster";
import {FileUploadService} from "../file/file-upload-service";
import {FileObjectService} from "../file/file-object.service";
import {ToastrService} from "ngx-toastr";
import {AccountService} from "../../singelton/account.service";
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {ISalesCycle, SalesCycle} from "../../shared/model/salesCycle.model";
import {EventService} from "../../singelton/event.service";
import {IStep} from "../../shared/model/step.model";
import {StepService} from "../step/step.service";
import {SHOW_SMS, TRANSACTION_DESCRIPTION_REQUIRED} from "../../app.constants";
import {SalesCycleService} from "../salesCycle/sales-cycle.service";
import {Supplier} from "../../shared/model/supplier.model";
import {IProjectItems, ProjectItems} from "../../shared/model/project-items.model";
import {INote} from "../../shared/model/note.model";
import {ProjectItemsService} from "../project/project-items.service";

@Component({
  selector: 'app-transaction-update',
  templateUrl: './transaction-update.component.html',
  styleUrls: ['./transaction-update.component.scss']

})
export class TransactionUpdateComponent implements OnInit {
  @Input() transactionEdit;
  @Input() projectItems;
  @Input() projects_list;
  @Input() salesCycles_list;
  @Input() contracts_list;
  @Input() phones_list;
  @Input() employees_list;
  @Input() customerId;
  @Input() supplierId;
  @Input() customer_project_param;
  @Input() customer_salesCycle_param;
  @Input() customer_contract_param;
  @Input() customer_order_param;
  @Input() type;
  @Input() part;
  @Input() action;
  @Input() fromWorkbench = false;

  get hideOptionalRelationFields(): boolean {
    if (this.fromWorkbench) {
      return true;
    }
    return this.action === 'add'
      && this.part === 'other'
      && !this.customerId
      && !this.supplierId
      && !this.customer_project_param
      && !this.customer_salesCycle_param
      && !this.customer_contract_param
      && !this.transactionEdit;
  }

  @Input() file_id;
  @Input() title;
  @Input() role;
  @Input() token;

  show_sms: any = SHOW_SMS;
  transactionDescriptionRequired = TRANSACTION_DESCRIPTION_REQUIRED;
  // business_tyep: any = BUSINESS_TYPE;

  fileObjects: IFileObject[] = [];
  showAddParam: boolean;
  editFormFile = this.fb.group({
    id: [],
    title: [],
    itemName: [],
    size: [],
    content: [],
    isImgProfile: [],
    imgProfile: [],
    status: [],
    uploaded_by: [],
    contentType: []
  });
  param1: any;
  file: IFileObject = new FileObject();
  T
  file_fileType: any;
  file_size: any;
  file_itemName: any;
  sortList: any;
  readonly = true;
  selected = 0;
  hovered = 0;

  profileImg: IFileObject;
  file_doctor: IFileObject;
  form: FormGroup;
  progress = 0;


  disableForm = false;
  project_step: any;
  actionType: IActionType = new ActionType();
  transaction: ITransaction = new Transaction();
  transaction_new: ITransaction = new Transaction();
  peygiry: ITransaction = new Transaction();
  /** Id of completed follow-up when creating the next one in a chain */
  chainParentId: number = null;
  followUpChain: ITransaction[] = [];
  chainLoading = false;
  isSaving: boolean;
  /** After save click with empty required fields — show red borders */
  formAttempted = false;
  isSavingTransaction = false;
  customer: ICustomer = new Customer();
  transaction_step_param = true;
  contracts: IContract[];
  projects: IProject[];
  salseCycles: ISalesCycle[];

  chekNeedFileUpload: Boolean = false;
  chekNeedFollow: Boolean = false;
  chekNeedFollow2: Boolean = false;
  chekNeedReminder: Boolean = false;
  customers: ICustomer[];

  dateObject: any;
  dateObject_reminder: any;
  dateObject_reminder2: any;
  dateObject2: any;
  dateObject_follow: any;
  datePickerConfig = {appendTo: '#tx-datepicker-portal', drops: 'down', opens: 'right'};
  private datePickerAnchor: HTMLElement | null = null;

  actionTypes: IActionType[];
  employees: IEmployee[];
  users: User[];
  error: any;
  success: any;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  isDisabledPeygiri = true;
  phones: IPhone[];
  steps: IStep[];

  projectItems_list: IProjectItems[] = [];

  keyword = 'title';
  audience_keyword = 'audience';
  audience_default = '';


  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  selectEvent(item) {
    this.customerId = item.id;
    this.transaction.customer = new Customer(item.id);
    this.loadAllProjectWithCustomerId(item.id);
    this.loadAllSalesCycleWithCustomerId(item.id);
    this.loadAllContractsWithCustomerId(item.id);
  }

  onChangeSearch(val: string) {
    this.customer.title = val;
    this.search(this.page);
  }

  onFocused(e) {
  }

  audience_selectEvent(item) {
    this.transaction.audience = item.audience;
  }

  audience_onChangeSearch(val: string) {
    this.transaction.audience = val;
  }

  audience_onFocused(e) {
  }

  onItemSelect(item: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  onDeSelect(item: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  onSelectAll(items: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  onDeSelectAll(items: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  currentDate: INote;
  h_temp: any;

  constructor(protected transactionService: TransactionService,
              protected eventService: EventService,
              protected customerService: CustomerService,
              protected salesCycleService: SalesCycleService,
              protected employeeService: EmployeeService,
              protected activatedRoute: ActivatedRoute,
              protected activeModal: NgbActiveModal,
              protected actionTypeService: ActionTypeService,
              public stepService: StepService,
              protected userService: UserService,
              private modalService: NgbModal,
              protected contractService: ContractService,
              protected projectService: ProjectService,
              protected phoneService: PhoneService,
              private spinner: NgxSpinnerService,
              protected dataUtils: JhiDataUtils,
              private fb: FormBuilder,
              protected fileObjectService: FileObjectService,
              private toastr: ToastrService,
              public accountService: AccountService,
              config: NgbRatingConfig,
              public projectItemsService: ProjectItemsService,
              public fileUploadService: FileUploadService) {

    this.itemsPerPage = 1000;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

    this.form = this.fb.group({
      name: [''],
      avatar: [null]
    });

  }


  private ensureDatePickerPortal() {
    if (document.getElementById('tx-datepicker-portal')) {
      return;
    }
    const portal = document.createElement('div');
    portal.id = 'tx-datepicker-portal';
    portal.className = 'tx-datepicker-portal';
    portal.style.position = 'fixed';
    portal.style.top = '0';
    portal.style.left = '0';
    portal.style.width = '0';
    portal.style.height = '0';
    portal.style.overflow = 'visible';
    portal.style.zIndex = '1200';
    document.body.appendChild(portal);
  }

  @HostListener('focusin', ['$event'])
  onDatePickerFocus(event: FocusEvent) {
    const target = event.target as HTMLElement;
    if (!target || !target.classList || !target.classList.contains('dp-picker-input')) {
      return;
    }
    this.datePickerAnchor = target;
    this.scheduleDatePickerPlacement();
  }

  @HostListener('window:resize')
  onDatePickerViewportChange() {
    this.scheduleDatePickerPlacement();
  }

  onModalBodyScroll() {
    if (!this.datePickerAnchor) {
      return;
    }
    const openPopup = document.querySelector('#tx-datepicker-portal .dp-popup:not([hidden])');
    if (!openPopup) {
      this.datePickerAnchor = null;
      return;
    }
    this.placeDatePicker(0);
  }

  private scheduleDatePickerPlacement() {
    setTimeout(() => this.placeDatePicker(0), 0);
  }

  private placeDatePicker(attempt: number) {
    const anchor = this.datePickerAnchor;
    if (!anchor) {
      return;
    }
    const popups = document.querySelectorAll('#tx-datepicker-portal .dp-popup');
    let popup: HTMLElement | null = null;
    for (let i = 0; i < popups.length; i++) {
      const candidate = popups[i] as HTMLElement;
      if (!candidate.hasAttribute('hidden') && candidate.getAttribute('data-hidden') !== 'true') {
        popup = candidate;
      }
    }
    if (!popup || !popup.offsetHeight) {
      if (attempt < 5) {
        setTimeout(() => this.placeDatePicker(attempt + 1), 40);
      }
      return;
    }
    const wrapper = popup.parentElement as HTMLElement;
    const field = (anchor.closest('dp-date-picker') as HTMLElement) || anchor;
    const anchorRect = field.getBoundingClientRect();
    const height = popup.offsetHeight;
    const width = popup.offsetWidth;
    const spaceBelow = window.innerHeight - anchorRect.bottom;
    const openUp = spaceBelow < height && anchorRect.top > height;
    const top = openUp ? anchorRect.top - height : anchorRect.bottom;
    let left = anchorRect.left;
    if (getComputedStyle(field).direction === 'rtl') {
      left = anchorRect.right - width;
    }
    if (left < 8) {
      left = 8;
    }
    if (left + width > window.innerWidth - 8) {
      left = Math.max(8, window.innerWidth - width - 8);
    }
    wrapper.style.position = 'static';
    wrapper.style.top = 'auto';
    wrapper.style.left = 'auto';
    wrapper.style.margin = '0';
    popup.style.position = 'fixed';
    popup.style.margin = '0';
    popup.style.right = 'auto';
    popup.style.bottom = 'auto';
    popup.style.top = top + 'px';
    popup.style.left = left + 'px';
    popup.style.zIndex = '1200';
  }

  ngOnInit() {
    this.ensureDatePickerPortal();
    this.loadAllStep();
    this.dropdownList = [
      {item_id: 1, item_text: 'ارسال نوتیفکیشن در برنامه'},
      {item_id: 2, item_text: 'ارسال سمس'},
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'انتخاب همه',
      searchPlaceholderText: 'جستجو',
      unSelectAllText: 'هیچکدام',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.isSaving = false;
    if (this.transactionEdit) {
      this.spinner.show();
      this.transactionService.find(this.transactionEdit).subscribe(
        (res: HttpResponse<ITransaction>) => {
          this.transaction = res.body;
          if (this.transaction && this.transaction.project && this.transaction.project.id) {
            this.transaction.project_str = this.transaction.project.id;
            this.loadAllProjectItemsWithPrjId(this.transaction.project.id);
          }
          if (this.transaction && this.transaction.salesCycle && this.transaction.salesCycle.id) {
            this.transaction.salesCycle_str = this.transaction.salesCycle.id;
          }
          if (this.transaction && this.transaction.contract && this.transaction.contract.id) {
            this.transaction.contract_str = this.transaction.contract.id;
          }

          if (this.transaction.status === 'Completed') {
            // this.disableForm = true;
          }
          if (!(this.transaction.step && this.transaction != null && this.transaction.step !== '')) {
            if (this.customer_project_param && this.customer_project_param.step) {
              this.transaction.step = this.customer_project_param.step;
            }
            if (this.customer_salesCycle_param && this.customer_salesCycle_param.step) {
              this.transaction.step = this.customer_salesCycle_param.step;
            }
            this.transaction_step_param = false;
          }
          if (!this.customer_project_param && this.part === 'other') {
            if (this.part === 'project') {
              this.loadAllGeneralActionTypes();
            } else {
              this.loadAllActionTypesMarketing();
            }
          } else {
            this.loadAllActionTypes();

          }


          this.audience_default = this.transaction.audience;
          if (this.transaction.jalaliDate) {
            const jalaliDate5 = moment(this.transaction.jalaliDate).locale('fa').format('jYYYY/jM/jD HH:mm:ss');

            this.dateObject = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
            this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          // if (this.transaction.jalaliDate_reminder) {
          //   const jalaliDate_reminder = moment(this.transaction.jalaliDate_reminder).locale('fa').format('jYYYY/jM/jD HH:mm:ss');
          //
          //   this.dateObject_reminder = moment(jalaliDate_reminder, 'jYYYY,jMM,jDD  HH:mm:ss');
          // }
          if (this.transaction.jalaliDateFollow) {
            const jalaliDate6 = moment(this.transaction.jalaliDateFollow).locale('fa').format('jYYYY/jM/jD HH:mm:ss');

            this.dateObject_follow = moment(jalaliDate6, 'jYYYY,jMM,jDD  HH:mm:ss');
          }

          if (this.supplierId) {
            this.transaction.supplier = new Supplier(this.supplierId);
            this.phones = this.phones_list;
            this.employees = this.employees_list;
          }
          if (this.customerId) {
            this.transaction.customer = new Customer(this.customerId);
            this.phones = this.phones_list;
            this.employees = this.employees_list;
            this.contracts = this.contracts_list;
            this.projects = this.projects_list;
            this.salseCycles = this.salesCycles_list;

          } else {
            this.phones = this.phones_list || [];
            this.employees = this.employees_list || [];
            this.contracts = this.contracts_list || [];
            this.projects = this.projects_list || [];
            this.salseCycles = this.salesCycles_list || [];

            this.search(1);
            this.setDefaultEmployeeForWorkbench();
          }

          if (!this.employees_list) {
            this.loadAllEmployee();
          }
          if (!this.phones_list) {
            this.loadPhone();
          }

          this.loadFollowUpChain(this.transaction.id);

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    } else {
      if (this.supplierId) {
        this.transaction.supplier = new Supplier(this.supplierId);
        this.phones = this.phones_list;
        this.employees = this.employees_list;
      }
      if (this.customerId) {
        this.transaction.customer = new Customer(this.customerId);
        this.phones = this.phones_list || [];
        this.employees = this.employees_list || [];
        this.contracts = this.contracts_list || [];
        this.projects = this.projects_list || [];
        this.salseCycles = this.salesCycles_list || [];

      } else {
        this.phones = this.phones_list || [];
        this.employees = this.employees_list || [];
        this.contracts = this.contracts_list || [];
        this.projects = this.projects_list || [];
        this.salseCycles = this.salesCycles_list || [];
        this.setDefaultEmployeeForWorkbench();

      }
    }
    this.transaction.project = this.customer_project_param || null;
    this.transaction.contract = this.customer_contract_param || null;
    this.transaction.order = this.customer_order_param || null;

    this.transaction.salesCycle = this.customer_salesCycle_param || null;
    if (this.customer_project_param && this.customer_project_param.id) {
      this.transaction.project_str = this.customer_project_param.id;
    }
    if (this.customer_contract_param && this.customer_contract_param.id) {
      this.transaction.contract_str = this.customer_contract_param.id;
    }
    if (this.customer_salesCycle_param && this.customer_salesCycle_param.id) {
      this.transaction.salesCycle_str = this.customer_salesCycle_param.id;
    }
    if ((!this.customer_project_param && this.part === 'other') || this.customer_contract_param || this.customer_order_param || (!this.customerId)) {
      if (this.part === 'project') {
        this.loadAllGeneralActionTypes();
      } else {
        this.loadAllActionTypesMarketing();
      }
    }


    if (!this.employees_list) {

      this.loadAllEmployee();
    }
  }


  loadPhone() {
    this.phoneService.findWithCustomerId(this.customerId).subscribe(
      (res: HttpResponse<IPhone[]>) => {
        this.phones = res.body;
        this.loadAllEmployee();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  search(page) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.customerService
      .searchAnutocomplete({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['title,asc'],
        title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }


  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();
  }

  loadAllCustomer() {
    this.spinner.show();
    this.customerService.query({
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: this.sort_c('title', 'asc')
    }).subscribe((res: HttpResponse<ICustomer[]>) => {
      this.customers = res.body;
      this.spinner.hide();

    }, (res: HttpErrorResponse) => this.onError(res.message));
  }


  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  sort_actionType() {
    const result = ['itemName' + ',' + (this.reverse ? 'asc' : 'desc')];
    // if (this.predicate !== 'itemName') {
    //   result.push('itemName');
    // }
    return result;
  }

  sort_by_name(predicate) {
    const result = [predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    return result;
  }


  sort_c(predicate, reverse) {
    const result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
    if (predicate !== 'id') {
      result.push('id');
    }
    return result;
  }


  private onSuccess(data, headers) {
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    this.users = data;
    this.spinner.hide();
  }

  loadAllActionTypesMarketing() {

    this.actionTypeService.query({
      page: 0,
      size: 100,
      sort: this.sort_actionType(),

    }).subscribe(
      (res: HttpResponse<IActionType[]>) => {
        this.actionTypes = res.body;
        this.spinner.hide();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );

  }

  loadAllGeneralActionTypes() {
    // alert(' in loadAllGeneralActionTypes ')

    this.actionTypeService.queryForGetGeneral({
      page: 0,
      size: 100,
      sort: this.sort_actionType(),
      // sort: 'item_name, asc',

    }).subscribe(
      (res: HttpResponse<IActionType[]>) => {
        this.actionTypes = res.body;
        this.spinner.hide();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );

  }


  loadAllStep() {
    this.stepService.query({
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: ['score', 'asc']

    }).subscribe(
      (res: HttpResponse<IStep[]>) => {
        this.steps = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllActionTypes() {
    // alert(' in loadAllActionTypes ')
    if (this.transaction.step_number) {
      this.actionTypeService.queryByStep(this.transaction.step_number).subscribe(
        (res: HttpResponse<IActionType[]>) => {
          this.actionTypes = res.body;
          this.spinner.hide();
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    } else {
      this.spinner.hide();

    }
  }


  loadAllContract() {
    this.projects = this.projects_list;
    this.contracts = this.contracts_list;
    this.spinner.hide();
  }


  loadAllProject() {
    this.loadAllContract();
  }


  sort2(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  loadAllSalesCycleWithCustomerId(id) {

    const customerId = id;
    this.salesCycleService
      .findWithCustomerId({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2(this.predicate, this.reverse),
        customerId
      }, customerId)
      .subscribe(
        (res: HttpResponse<ISalesCycle[]>) => this.paginateSalesCycle(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  loadAllContractsWithCustomerId(id) {
    this.spinner.show();

    this.contractService.findWithCustomerId(id).subscribe(
      (res: HttpResponse<IContract[]>) => {
        this.contracts = res.body;

        this.spinner.hide();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  protected paginateSalesCycle(data: IProject[], headers: HttpHeaders) {

    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.salseCycles = data;

  }

  loadAllProjectWithCustomerId(id) {

    const customerId = id;
    this.projectService
      .findWithCustomerId({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2(this.predicate, this.reverse),
        customerId
      }, customerId)
      .subscribe(
        (res: HttpResponse<IProject[]>) => this.paginateProject(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected paginateProject(data: IProject[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.projects = data;
  }

  protected paginateContracts(data: IContract[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.contracts = data;
    this.spinner.hide();
  }


  protected paginateProjects(data: IProject[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.projects = data;
    this.loadAllContract();

  }

  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;

        if ((!this.customer_project_param && this.part === 'other') || this.projectItems) {

          if (this.part === 'project') {
            this.loadAllGeneralActionTypes();
          } else {
            this.loadAllActionTypesMarketing();

          }
        } else {

          this.loadAllActionTypes();

        }

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  previousState() {
    window.history.back();
  }


  setDefaultEmployeeForWorkbench() {
    if (this.transactionEdit || this.transaction.employee_str || this.part !== 'other') {
      return;
    }
    this.accountService.identity().then(account => {
      if (account && account.id) {
        this.employeeService.findByUserId(account.id).subscribe(empl => {
          if (empl.body && empl.body.id && !this.transaction.employee_str) {
            this.transaction.employee_str = empl.body.id;
          }
        });
      }
    });
  }

  save(editForm?: NgForm) {
    if (editForm && editForm.invalid) {
      this.formAttempted = true;
      Object.keys(editForm.controls).forEach(key => {
        editForm.controls[key].markAsTouched();
        editForm.controls[key].markAsDirty();
      });
      this.toastr.warning('لطفاً فیلدهای ضروری (کادر قرمز) را تکمیل کنید.');
      setTimeout(() => {
        const el = document.querySelector('.tx-update-form .ng-invalid') as HTMLElement;
        if (el) {
          el.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      });
      return;
    }

    if (this.editFormFile.get(['content']).value && !this.editFormFile.get(['title']).value) {
      alert(' کاربر گرامی لطفاً عنوان فایل آپلود شده را وارد کنید. ');

    } else {


      this.isSaving = true;
      const span_followDate = document.getElementById('span_followDate');
      if (this.transaction.employee_str) {
        this.transaction.employee = new Employee(this.transaction.employee_str);
      } else {
        this.transaction.employee = null;
      }
      if (this.transaction.contract_str) {
        this.transaction.contract = new Contract(this.transaction.contract_str);
      } else {
        this.transaction.contract = null;
      }
      if (this.transaction.project_item_str) {
        this.transaction.projectItem = new ProjectItems(this.transaction.project_item_str);
      } else {
        this.transaction.projectItem = null;
      }
      // if (this.transaction.item_number) {
      //   this.transaction.projectItem = new ProjectItems(this.transaction.item_number);
      // }
      if (this.transaction.project_str) {
        this.transaction.project = new Project(this.transaction.project_str);
      } else if (this.transaction.project && this.transaction.project.id) {
        this.transaction.project = new Project(this.transaction.project.id);
      } else if (this.customer_project_param && this.customer_project_param.id) {
        this.transaction.project = new Project(this.customer_project_param.id);
      } else {
        this.transaction.project = null;
      }
      if (this.transaction.salesCycle_str) {
        this.transaction.salesCycle = new SalesCycle(this.transaction.salesCycle_str);
      } else if (this.transaction.salesCycle && this.transaction.salesCycle.id) {
        this.transaction.salesCycle = new SalesCycle(this.transaction.salesCycle.id);
      } else if (this.customer_salesCycle_param && this.customer_salesCycle_param.id) {
        this.transaction.salesCycle = new SalesCycle(this.customer_salesCycle_param.id);
      } else {
        this.transaction.salesCycle = null;
      }
      if (this.transaction.customer && this.transaction.customer.id) {
        this.transaction.customer = new Customer(this.transaction.customer.id);
      } else {
        this.transaction.customer = null;
      }
      this.transaction.organization = new Organization(1);

      const span_actionDate = document.getElementById('span_actionDate');
      const span_actionDate2 = document.getElementById('span_actionDate2');
      if (span_actionDate2 && (<HTMLInputElement>span_actionDate2).innerHTML) {
        this.transaction.jalaliDate = (<HTMLInputElement>span_actionDate2).innerHTML;
      } else if (span_actionDate) {
        this.transaction.jalaliDate = (<HTMLInputElement>span_actionDate).innerHTML;
      }

      const span_actionDate_reminder = document.getElementById('span_actionDate_reminder');
      if (span_actionDate_reminder) {
        this.transaction.jalaliDate_reminder = (<HTMLInputElement>span_actionDate_reminder).innerHTML;
        const date_split: any[] = this.transaction.jalaliDate_reminder.split(' ');
        let date_time_reminder = date_split[0] + ' ' + date_split[1] + ' ' + date_split[2] + ' ' + date_split[3] + ' ' + this.dateObject_reminder2 + ':00 ' + date_split[5];

        this.transaction.jalaliDate_reminder = date_time_reminder;
      }
      if (span_followDate) {
        this.transaction.jalaliDateFollow = (<HTMLInputElement>span_followDate).innerHTML;
      }

      if (this.type === 'Action') {
        this.transaction.status = 'Completed';
        this.transaction.type = 'Action';

      } else if (this.type === 'Follow') {
        this.transaction.status = 'In_progress';
        this.transaction.type = 'Follow';
      }
      const user = new User();

      if (this.action === 'completed') {
        this.transaction.status = 'Completed';

      }


      if (this.transaction.id !== undefined) {
        this.subscribeToSaveResponse(this.transactionService.update(this.transaction));
      } else {
        this.subscribeToSaveResponse(this.transactionService.create(this.transaction));
      }


      if (this.type === 'Action') {
        this.transaction.status = 'Completed';
        this.transaction.type = 'Action';

      } else if (this.type === 'Follow') {
        this.transaction.status = 'In_progress';
        this.transaction.status = 'Follow';
      }
    }
  }

  sendAndUpdate() {
    this.isSaving = true;
    const user = new User();
    if (this.transaction.id !== undefined) {
      this.subscribeToSaveResponse_send(this.transactionService.update(this.transaction));
    } else {
      this.subscribeToSaveResponse_send(this.transactionService.create(this.transaction));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<ITransaction>>) {
    result.subscribe((res: HttpResponse<ITransaction>) => this.onSaveSuccess(res.body), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected subscribeToSaveResponse_send(result: Observable<HttpResponse<ITransaction>>) {
    result.subscribe((res: HttpResponse<ITransaction>) => this.onSaveSuccess_send(res.body), (res: HttpErrorResponse) => this.onSaveError());
  }

  loadAllProjectItemsWithPrjId(projectId) {

    // const projectId = this.project.id;
    this.projectItemsService
      .findWithProjectId({
        // .findAllProjectItemsForCalnedar({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2('score', 'asc'),

      }, projectId)
      .subscribe(
        (res: HttpResponse<IProjectItems[]>) => this.paginateProjectItems_list(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }

  protected paginateProjectItems_list(data: IProjectItems[], headers: HttpHeaders) {
    // alert('paginateProjectItems_list ');
    // this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    // this.queryCount = this.totalItems;
    this.projectItems = data;
  }


  protected onSaveSuccess(data) {
    // alert(' in save succcc');
    // alert(' in save projectItems = ' + this.projectItems);
    this.eventService.onAddEvent('test message 22');
    this.eventService.onSalesAddEvent('test message 22');

    this.isSaving = false;
    this.transaction = data;
    if (this.type === 'Task') {
      // alert(' in if  Task');

      this.isSavingTransaction = true;
      if (this.editFormFile.get(['content']).value) {
        this.saveFile();

      } else {
        this.clear();
      }

    } else {
      // alert(' in else  Task');

      if (this.chekNeedFollow === true) {
        this.chekNeedFollow2 = true;
        // alert(' in if  chekNeedFollow');
        // alert('756 ')
        if (this.editFormFile.get(['content']).value) {
          // alert('in if content saveFile ')

          this.saveFile();

        }

        this.type = 'Follow';
        this.action = 'add';

        this.chainParentId = this.transaction.id;
        this.transaction_new = new Transaction();
        this.transaction_new.parentId = this.chainParentId;
        this.transaction_new.rootId = this.transaction.rootId || this.transaction.id;
        this.transaction_new.customer = this.transaction.customer;
        if (this.transaction.customer) {
          this.customerId = this.transaction.customer.id;
        }
        // alert(' this.transaction.project = ' + this.transaction.project)

        if (this.transaction.project) {
          // alert(' in if project ')
          this.part = 'project';
          this.customer_project_param = this.transaction.project;
        }
        // alert(' this.transaction.salesCycle = ' + this.transaction.salesCycle)

        if (this.transaction.salesCycle) {
          // alert(' in if salesCycle ')

          this.part = 'salesCycle';
          this.customer_salesCycle_param = this.transaction.salesCycle;

        }

        if (this.transaction.contract) {
          this.part = 'contract';
          this.customer_contract_param = this.transaction.contract;

        }
        if (this.transaction.order) {
          this.part = 'order';
          this.customer_order_param = this.transaction.order;

        }

        this.transaction_new.audience = this.transaction.audience;
        this.transaction_new.step_number = this.transaction.step_number;
        this.transaction_new.actionDate = null;
        this.transaction_new.followupbyDate = null;
        this.transaction_new.jalaliDate = null;
        this.transaction_new.jalaliDateFollow = null;
        this.transaction_new.project = this.customer_project_param;
        this.transaction_new.contract = this.customer_contract_param;
        this.transaction_new.order = this.customer_order_param;
        this.transaction_new.salesCycle = this.customer_salesCycle_param;
        this.dateObject = null;
        this.dateObject_follow = null;
        this.dateObject2 = null;
        this.transaction = this.transaction_new;
        this.chekNeedFollow = false;
        this.chekNeedFollow2 = true;
        if (this.chainParentId) {
          this.loadFollowUpChain(this.chainParentId);
        }

      } else {
        // alert(' in else  chekNeedFollow');
        this.chekNeedFollow2 = false;

        if (this.editFormFile.get(['content']).value) {
          this.saveFile();

        } else {
          this.clear();

        }

        // this.activeModal.dismiss('cancel');

      }

    }

  }


  protected subscribeToSaveResponseProject(result: Observable<HttpResponse<IProject>>) {
    result.subscribe((res: HttpResponse<IContract>) => this.onSaveSuccessProject(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccessProject() {
    this.isSaving = false;
    this.clear();
  }


  protected onSaveSuccess_send(data) {

    this.isSaving = false;
    this.isSavingTransaction = true;
    this.transaction = data;
    this.activeModal.dismiss('cancel');

  }

  protected onSaveError() {
    this.isSaving = false;
    this.toastr.error('خطا در ذخیره پیگیری. لطفاً فیلدهای ضروری را بررسی کنید.');
  }

  protected onError(errorMessage: string) {
  }

  trackCustomerById(index: number, item: ICustomer) {
    return item.id;
  }

  loadFollowUpChain(id: number) {
    if (!id) {
      this.followUpChain = [];
      return;
    }
    this.chainLoading = true;
    this.transactionService.findChain(id).subscribe(
      (res: HttpResponse<ITransaction[]>) => {
        this.followUpChain = res.body || [];
        this.chainLoading = false;
      },
      () => {
        this.followUpChain = [];
        this.chainLoading = false;
      }
    );
  }

  get hasFollowUpChain(): boolean {
    return !!(this.followUpChain && this.followUpChain.length > 1) || !!this.chainParentId;
  }

  chainItemLabel(item: ITransaction): string {
    if (!item) {
      return '—';
    }
    const action = item.action || 'پیگیری';
    const who = item.createdBy || item.createbyS || '';
    return who ? `${action} — ${who}` : action;
  }

  chainItemDate(item: ITransaction): string {
    if (!item) {
      return '';
    }
    const raw = item.createdDate || item.created_date || item.createDate;
    if (!raw) {
      return '';
    }
    return moment(new Date(raw as any)).locale('fa').format('jYYYY/jM/jD HH:mm');
  }

  chainStatusLabel(status: string): string {
    if (status === 'Completed') {
      return 'تکمیل‌شده';
    }
    if (status === 'In_progress' || status === 'Follow') {
      return 'باز';
    }
    return status || '—';
  }

  isCurrentChainItem(item: ITransaction): boolean {
    if (!item || !item.id) {
      return !this.transaction.id && !!this.chainParentId;
    }
    return this.transaction && this.transaction.id === item.id;
  }

  clear() {
    this.activeModal.dismiss('cancel');
  }

  send() {
    this.sendAndUpdate();
  }


  loadCustomer() {
    if (this.customerId) {
      this.customerService.find(this.customerId).subscribe(
        (res: HttpResponse<ICustomer>) => {
          this.customer = res.body;
          this.transaction.customer = this.customer;
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
  }

  onChangesPeygiriChecked(deviceValue) {
    if (deviceValue.target.checked) {
      this.isDisabledPeygiri = false;
    } else {
      this.isDisabledPeygiri = true;
    }
  }


  addActionType(content?) {

    const modalRef = this.modalService.open(ActionTypeUpdateComponent, {windowClass: 'lg', backdrop: 'static'});

    modalRef.result.then(
      res => {
        this.reloadActionTypes();
      },
      rejected => {
        this.reloadActionTypes();
      }
    );

  }

  private reloadActionTypes() {
    if ((!this.customer_project_param && this.part === 'other') || this.customer_contract_param || this.customer_order_param || (!this.customerId)) {
      if (this.part === 'project') {
        this.loadAllGeneralActionTypes();
      } else {
        this.loadAllActionTypesMarketing();
      }
    } else {
      this.loadAllActionTypes();
    }
  }


  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({
      avatar: file
    });
    this.form.get('avatar').updateValueAndValidity();
  }

  submitUser() {
    this.isSaving = true;

    const fileObject = this.createFormFile();
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.updateProfile(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.createProfileImg(fileObject));
    }

  }


  private onSuccessProfile(data, headers) {
    this.fileObjects = data;
    this.totalItems = headers.get('X-Total-Count');
    if (this.fileObjects && this.fileObjects.length > 0) {
      this.profileImg = this.fileObjects[0];
      if (this.profileImg) {
        this.updateFormFile(this.profileImg);
      }
    }
  }

  myFunction(id) {
    const x = document.getElementById(id);

    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  }


  showAdd() {
    this.showAddParam = true;
    this.createFormFile();
  }


  open(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  updateFormFile(fileObject: IFileObject) {
    this.editFormFile.patchValue({
      id: fileObject.id,
      title: fileObject.title,
      content: fileObject.content,
      itemName: fileObject.contentType,
      size: fileObject.contentType,
      isImgProfile: fileObject.isImgProfile,
      imgProfile: fileObject.imgProfile,
      status: fileObject.status,
      uploaded_by: fileObject.uploaded_by,
      contentType: (this.action === 'approve' ? 'Approved' : fileObject.contentType)
    });
  }

  byteSize(field) {
  }

  openFile(contentType, field) {
  }

  setFileData(event, field: string, isImage) {
    const name = <HTMLInputElement>document.getElementById('file_content');


    this.file_itemName = name.files.item(0).name;
    this.file_size = name.files.item(0).size + '';
    this.file_fileType = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      () => console.log('blob added'),
      this.onError
    );


  }

  setReminderType() {
    if (this.transaction.reminderMe) {
      this.transaction.reminderMe_type = 'sms';
    } else {
      this.transaction.reminderMe_type = '';

    }
  }

  hide() {
    this.showAddParam = false;
    this.createFormFile();
  }

  saveFile() {
    // alert('in saveFile ')

    this.isSaving = true;
    this.progress = Math.round(200 / 200 * 100);
    const fileObject = this.createFormFile();
    fileObject.customer = new Customer(this.customerId);
    if (this.transaction) {
      fileObject.transaction = this.transaction;
    }
    if (this.transaction.project) {
      fileObject.project = this.transaction.project;
    }
    if (this.transaction.salesCycle) {
      fileObject.salesCycle = this.transaction.salesCycle;
    }
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.update(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.create(fileObject));
    }

  }

  approve() {
    this.isSaving = true;

    this.file_doctor.status = 'Approved';
    this.subscribeToSaveResponseFile(this.fileObjectService.update(this.file_doctor));

  }

  private createFormFile(): IFileObject {
    return {
      ...new FileObject(),
      id: this.editFormFile.get(['id']).value,
      title: (this.title === 'profileImg' ? 'عکس پروفایل' : this.editFormFile.get(['title']).value),
      uploaded_by: (this.role ? this.role : this.editFormFile.get(['uploaded_by']).value),
      contentType: this.file_fileType,
      itemName: this.file_itemName,
      size: this.file_size,
      isImgProfile: true,
      imgProfile: true,
      status: (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) ? 'Approved' : 'Pending'),
      content: this.editFormFile.get(['content']).value
    };
  }


  protected subscribeToSaveResponseFile(result: Observable<HttpResponse<IFileObject>>) {
    // alert('in subscribeToSaveResponseFile ')

    result.subscribe(() => this.onSaveSuccessFile(), () => this.onSaveErrorFile());

  }

  protected onSaveSuccessFile() {
    // alert('in onSaveSuccessFile ')

    this.isSaving = false;
    this.showAddParam = false;
    // alert(' chekNeedFollow=='+this.chekNeedFollow)

    if (this.chekNeedFollow2) {
      // alert(' 111111')
      this.updateFormFile(new FileObject());
    } else {
      // alert(' in else')

      this.clear();

    }
    this.toastr.success('.ثبت فایل شما با موفقیت انجام شد', '!موفق');
    this.chekNeedFileUpload = false;
    this.chekNeedFollow = false;
    this.chekNeedFollow2 = false;
  }


  protected onSaveErrorFile() {
    this.isSaving = false;
  }
}
